module.exports = __webpack_public_path__ + "img/09陈利军.37e54f20.png";